import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography, useTheme } from "@mui/material";
import { NavLink } from "react-router-dom";
import { MyMealsMenu } from "../MyMealsMenu/MainComponents/MyMealsMenu";
import { NavDrawerMenuItem } from "../NavDrawerMenuItem";
import { AccountRoutesType } from "../navigationUtils";
import { getAccessibleTextColor } from "../../BrandingProvider/mealTrackThemeConfigurations";
const isActive = (location, nav) => location.pathname === nav.to && nav.to !== AccountRoutesType.LOGOUT;
export const NavDrawerLinks = ({ links }) => {
    var _a, _b;
    const theme = useTheme();
    const selectedColor = theme.palette.common.black;
    const headerTextColor = ((_a = theme.palette.header) === null || _a === void 0 ? void 0 : _a.textColor) || theme.palette.common.black;
    const headerBgColor = ((_b = theme.palette.header) === null || _b === void 0 ? void 0 : _b.backgroundColor) || theme.palette.common.white;
    const headerNavTextColor = getAccessibleTextColor(theme, headerTextColor, headerBgColor);
    return (_jsx(_Fragment, { children: links.map((nav) => {
            if (nav.to === AccountRoutesType.MY_MEALS) {
                return _jsx(MyMealsMenu, { displayText: nav.displayText, isNavDrawer: true }, nav.to);
            }
            else {
                return (_jsx(NavDrawerMenuItem, Object.assign({ component: NavLink, to: nav.to, selected: isActive(location, nav), className: nav.to === AccountRoutesType.LOGOUT ? "is-logout" : "" }, { children: _jsx(Typography, Object.assign({ variant: "h4", color: isActive(location, nav) ? selectedColor : headerNavTextColor }, { children: nav.displayText })) }), nav.to));
            }
        }) }));
};
